/** Detects whether the current page load is a reload, across both the modern and legacy navigation APIs. */
export const isPageReload = (): boolean => {
    if (typeof window === "undefined" || typeof performance === "undefined") {
        return false;
    }

    const perf = performance as Performance & {
        navigation?: PerformanceNavigation & { TYPE_RELOAD?: number };
    };

    const navEntries = perf.getEntriesByType?.("navigation") as PerformanceNavigationTiming[] | undefined;
    const navigationType = navEntries && navEntries.length > 0
        ? navEntries[0].type
        : perf.navigation?.type;

    return navigationType === "reload" || navigationType === perf.navigation?.TYPE_RELOAD;
};
